import {TrackingRepository} from '@/common/repositories/track/TrackingRepository';
import {ProfileCreationStepGroup} from '../config/steps/ProfileCreationSteps';
import {ProfileCreationTrackingEvents} from './ProfileCreationTrackingEvents';
import {track} from '@malt/tracking';
const trackingRepository = new TrackingRepository();

export type ProfileCreationStepNavigationTrackingEvent = {
    stepName: string;
    funnelModeName: string;
    isGoingToFirstStepOfItsGroup: boolean;
    group: ProfileCreationStepGroup;
};

export function trackStepsNavigation(event: ProfileCreationStepNavigationTrackingEvent) {
    if (event.stepName && event.funnelModeName) {
        trackNavigationEvents(event);
        trackingRepository.track(`${event.stepName}-view-page-${event.funnelModeName}`);
    }
}

function trackNavigationEvents(event: ProfileCreationStepNavigationTrackingEvent) {
    if (event.isGoingToFirstStepOfItsGroup) {
        switch (event.group) {
            case ProfileCreationStepGroup.SIGNUP: {
                track(ProfileCreationTrackingEvents.PROFILE_CREATION_STARTED, {funnel_mode: event.funnelModeName});
                break;
            }
            case ProfileCreationStepGroup.COMPLETION: {
                track(ProfileCreationTrackingEvents.PROFILE_CREATED, {funnel_mode: event.funnelModeName});
                break;
            }
        }
    }
}
